export default __webpack_public_path__ + "static/media/refresh-green.136fac2b.svg";